import React, {useEffect, useState} from 'react'
import {TextInput} from '../../../../components/inputs/TextInput'
import {SelectInput} from '../../../../components/inputs/SelectInput'
import {useFormik} from 'formik'
import {ModeleRemise} from '../../../../components/Models'
import {getReferentielLists} from '../../../../components/clientParametrage/requests'
import {
  ModelReferentielLists,
  ModelReferentielListsInitValues,
} from '../../../../components/clientParametrage/Models'
import * as Yup from 'yup'
import SelectPieces from './SelectPieces'
import {useNavigate} from 'react-router-dom'

const remiseSchema = Yup.object().shape({
  idGroupeClient: Yup.string().required('Le groupe client est requis'),
  taux: Yup.string().required('Le taux est requis'),
})

const RemiseForm = (props) => {
  const {remiseId} = props
  const navigate = useNavigate()
  const initialValue = {...props.data}
  const [data, setData] = useState<ModeleRemise>(initialValue)
  const [referentielData, setReferentielData] = useState<ModelReferentielLists>(
    ModelReferentielListsInitValues
  )
  const [referentialGrpClient, setReferentialGrpClient] = useState({
    clientGroupeList: referentielData.clientGroupeList ?? [],
  })
  const [loading, setLoading] = useState(false)
  const [loadingGC, setLoadingGC] = useState(true)
  const [sauf, setSauf] = useState<any>([])

  // Récupération des groupes clients pour les options du sélecteur
  const getReferentielData = () => {
    setLoadingGC(true)
    getReferentielLists().then((referentielListQueryResponse) => {
      if (referentielListQueryResponse?.status === 200 && referentielListQueryResponse?.data) {
        const updatedReferentielData = Object.assign(
          {...referentielData},
          referentielListQueryResponse?.data
        )
        setReferentialGrpClient({...updatedReferentielData})
        // Sélection de la première option par défaut pour l'ajout
        if (!remiseId && referentielListQueryResponse.data.clientGroupeList?.length > 0) {
          formik.setFieldValue(
            'idGroupeClient',
            referentielListQueryResponse.data.clientGroupeList[0].value
          )
        }
      }
      setLoading(false)
      setTimeout(() => { setLoadingGC(false) }, 1000)
    })
  }

  useEffect(() => {
    if (props.data) setData(props.data)
    if (props.data && props.data.sauf) setSauf(props.data.sauf)
  }, [props.data])

  useEffect(() => {
    getReferentielData()
  }, [])

  // Gestion des pièces excluses du frais de transport offert
  const handleSelect = (newValue: any) => {
    setSauf(newValue)
  }

  const formik = useFormik<ModeleRemise>({
    enableReinitialize: true,
    initialValues: data,
    validationSchema: remiseSchema,
    onSubmit: (values) => {
      setLoading(true)
      setTimeout(() => {
        const updatedData = Object.assign({...data}, values, {sauf: values.offert ? sauf : []})

        props.submitForm(updatedData, (response) => {
          formik.resetForm()
          setLoading(false)
        })
      }, 200)
    },
  })

  return (
    <div>
      <form noValidate className='form' onSubmit={formik.handleSubmit}>
        <div className='card-body border-top p-9'>
          <div className='row mb-6'>
            <label className='col-lg-4 col-form-label required fw-bold fs-6'>Groupe client</label>
            <div className='col-lg-8'>
              <div className='row'>
                <div className='col-lg-6 fv-row'>
                  {loadingGC ?
                    <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                    :
                    <SelectInput
                      fieldName={'idGroupeClient'}
                      inputClassName={'form-select form-select-solid form-select-lg fw-bold'}
                      options={referentialGrpClient.clientGroupeList}
                      formik={formik}
                    />
                  }
                </div>
              </div>
            </div>
          </div>
          <div className='row mb-6'>
            <label className='col-lg-4 col-form-label required fw-bold fs-6'>
              Taux de remise (%)
            </label>
            <div className='col-lg-8'>
              <div className='row'>
                <div className='col-lg-6 fv-row'>
                  <TextInput
                    fieldName={'taux'}
                    inputPlaceholder={'Taux de remise'}
                    inputType={'number'}
                    min={0}
                    max={100}
                    inputClassName={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                    formik={formik}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className='form-check'>
            <input
              className='form-check-input'
              type='checkbox'
              name='offert'
              id='offert'
              checked={formik.values.offert}
              onChange={(e) => formik.setFieldValue('offert', e.target.checked)}
            />
            <label className='form-check-label' htmlFor='checkDefault'>
              Frais de port offert
            </label>
          </div>
          {formik.values.offert && (
            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label required fw-bold fs-6'>Sauf</label>
              <div className='col-lg-8'>
                <div className='row'>
                  <div className='col-lg-6 fv-row'>
                    <SelectPieces onSelect={handleSelect} selectedValues={sauf} />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className='card-footer d-flex justify-content-end py-6 px-9'>
          <button
            type='button'
            className='btn btn-light me-3'
            disabled={loading}
            onClick={() => {
              formik.resetForm()
              navigate(`/remise/groupe/liste`)
            }}
          >
            Annuler
          </button>
          <button type='submit' className='btn btn-primary' disabled={loading}>
            {!loading && 'Enregistrer'}
            {loading && (
              <span className='indicator-progress' style={{display: 'block'}}>
                Enregistrement...{' '}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
        </div>
      </form>
    </div>
  )
}

export default RemiseForm
